import i18next from "i18next";
import { html } from "lit-html";

export const stationCommonTemplates = () => {
	// EXPORTS
	const noResultTemplate = () =>
		html`<div class="bg-white p-5 font-body text-lg leading-5 text-n-red">${i18next.t("No hay resultados.")}</div>`;

	return { noResultTemplate };
};
